import { useInstanceStore } from '@/store/backendInstances.js'
import { computed } from 'vue'
import BackendAPI from '@/BackendAPI.js'

/**
 * Precondition that checks if the instance is online.
 * @param globalUniqueIdentifier {string} - The unique identifier of the instance.
 * @returns {ComputedRef<boolean>}
 */
const isOnlinePrecondition = globalUniqueIdentifier => {
  const { isOnline } = useInstanceStore()
  return computed(() => {
    if (!globalUniqueIdentifier) return false
    return isOnline(globalUniqueIdentifier)
  })
}

/**
 * Precondition that checks if the user is logged in to the instance.
 * @param globalUniqueIdentifier
 * @returns {ComputedRef<boolean>}
 */
const isLoggedInPrecondition = globalUniqueIdentifier => {
  const { isLoggedIn } = useInstanceStore()
  return computed(() => {
    if (!globalUniqueIdentifier) return false
    return isLoggedIn(globalUniqueIdentifier)
  })
}

/**
 * Checks if the user is logged in to the senator instance.
 * @returns {ComputedRef<*>}
 */
const isSenatorLoggedInPrecondition = () => {
  const { isLoggedIn } = useInstanceStore()
  return computed(() => isLoggedIn('66'))
}
/**
 * Precondition that checks if the instance is a barn.
 * @param globalUniqueIdentifier
 * @returns {ComputedRef<boolean>}
 */
const isBarnPrecondition = globalUniqueIdentifier => {
  const { instances } = useInstanceStore()
  return computed(() => instances[globalUniqueIdentifier]?.instanceType === 'barn')
}

/**
 * Precondition that checks if the instance is a senator.
 * @param globalUniqueIdentifier
 * @returns {ComputedRef<boolean>}
 */
const isSenatorPrecondition = globalUniqueIdentifier => {
  const { instances } = useInstanceStore()
  return computed(() => instances[globalUniqueIdentifier]?.instanceType === 'senator')
}

const isInstanceNotStalePrecondition = globalUniqueIdentifier => {
  const instance = BackendAPI.getOrCreateBackendAPIInstance(globalUniqueIdentifier)
  return computed(() => !instance.isInstanceStale())
}

export {
  isOnlinePrecondition,
  isLoggedInPrecondition,
  isBarnPrecondition,
  isInstanceNotStalePrecondition,
  isSenatorPrecondition,
  isSenatorLoggedInPrecondition,
}
